export const EMPTY = "—";
export const SPACE = "\u00A0";
